module.exports = __webpack_public_path__ + "media/images/area/area_kanagawaM400-64ee076d223e6dac40eb7c34b094e20f.jpg";